import {
  Box,
  Button,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect } from "react";
import CartListRow from "./CartListRow";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCartFromServer,
  clear,
} from "../../../../Store/Slices/CartSlice/cartSlice";
import { GradientBorderBox } from "../../../../Components";

export default function CartList() {
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.userSlice);
  const { list } = useSelector((state) => state.cartSlice);

  // fetch cart from server when user logs in
  useEffect(() => {
    if (token) {
      dispatch(getCartFromServer());
    }
  }, [token, dispatch]);

  // derive filtered list directly (no need for local state)
  const filteredList = token ? list.filter((item) => item.quantity > 0) : list;

  const deleteItemFromCart = (code, variant_code) => {
    dispatch(clear({ code, variant_code }));
  };

  const listItemCart =
    filteredList?.length > 0 ? (
      filteredList.map((item) => (
        <CartListRow
          key={item.variant_code}
          item={item}
          clearFullyCart={deleteItemFromCart}
        />
      ))
    ) : (
      <></>
    );
  // const listItemCart = Array(5)
  //   .fill({ name: "test" })
  //   ?.map((item) => {
  //     return (
  //       <CartListRow
  //         key={item.variant_code}
  //         item={item}
  //         clearFullyCart={deleteItemFromCart}
  //       />
  //     );
  //   });

  return (
    <Container
      maxWidth={"xxl"}
      sx={{
        pt: "1rem",
        gap: "1.5rem",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header (mobile title) */}
      <Typography
        sx={{
          textAlign: "center",
          mb: "1rem",
          fontSize: "1.2rem",
          fontWeight: "bold",
          color: theme.palette.primary.main,
          display: { xs: "block", md: "none" },
        }}
      >
        سبد خرید
      </Typography>

      {/* Header (desktop columns) */}
      <Stack
        direction={"row-reverse"}
        sx={{
          // bgcolor: theme.palette.secondary.main,
          color: "white",
          padding: ".8rem",
          borderRadius: "6px",
          display: { xs: "none", md: "flex" },
          position: "relative",
          backdropFilter: "blur(16px)",
        }}
      >
        <Stack
          direction={"row"}
          sx={{
            // border: `2px solid ${theme.palette.primary.main}`,
            borderRadius: "6px",
            padding: "1rem",
            direction: "rtl",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "right", width: "30%" }}
          >
            عنوان محصول
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "center", width: "10%" }}
          >
            رنگ
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "center", width: "20%" }}
          >
            قیمت واحد (تومان)
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "center", width: "15%" }}
          >
            تعداد
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "center", width: "20%" }}
          >
            قیمت کل (تومان)
          </Typography>
          <Typography
            sx={{ fontSize: ".8rem", textAlign: "left", width: "5%" }}
          >
            حذف
          </Typography>
        </Stack>
        <GradientBorderBox radius=".5rem" borderSize="3px" />
        <Box
          sx={{
            position: "absolute",
            top: "65%",
            left: "20%",
            transform: "translate(-10% , -45%)",
            zIndex: "-10",
            width: "200px",
            height: "200px",
          }}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src="/Media/Circles/circle.svg"
            alt="circle images"
          />
        </Box>
      </Stack>

      {/* Content */}
      <Stack sx={{ gap: ".5rem" }}>{listItemCart}</Stack>

      {/* Buttons */}
      <Stack
        direction={"row"}
        sx={{
          width: { xs: "90%", sm: "100%" },
          mx: "auto",
          maxWidth: { xs: "350px", md: "600px" },
          minWidth: "300px",
          borderRadius: "6px",
          padding: "8px",
          gap: ".5rem",
          my: "2rem",
          position: "relative",
        }}
      >
        <Button
          disabled={list.length > 0 ? false : true}
          onClick={() =>
            token ? navigate("/cart/confirm") : navigate("/auth")
          }
          sx={{ width: "100%" }}
          size="large"
          variant="contained"
        >
          ادامه خرید
        </Button>
        <Button
          onClick={() => navigate("/")}
          sx={{ width: "100%" }}
          size="large"
          variant="outlined"
        >
          بازگشت به فروشگاه
        </Button>
        <GradientBorderBox
          bgGrad={`linear-gradient(
    90deg,
    #fff -30%,
    #313131 50%,
     #DCB868 130%
  )`}
          radius=".5rem"
          borderSize="2px"
        />
      </Stack>
    </Container>
  );
}
